import { useState } from "react";
import * as React from "react";
import Box from "@mui/material/Box";
import Input from "@mui/material/Input";
import BasePanel from "src/components/UI/Shared/BasePanel";
import { useNavigate } from "react-router";
import PrintVM from "@arcgis/core/widgets/Print/PrintViewModel";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import PopupState, { bindTrigger, bindMenu } from "material-ui-popup-state";
import Store from "src/data/store";
import PrintTemplate from "@arcgis/core/rest/support/PrintTemplate";
import styles from "./assetes/css/Print.module.scss";
import Divider from "@mui/material/Divider";
import path from "src/config/search.json";
// redux
import { useSelector, useDispatch } from "react-redux";
import { appActions } from "src/store/store";
// data
const store = Store.getInstance();

const Printt = () => {
  const dispatch = useDispatch();
  const activePanel = useSelector((state: any) => state.app.activePanel);

  type PrintFormat =
    | "pdf"
    | "png32"
    | "jpg"
    | "gif"
    | "svg"
    | "svgz"
    | "png8"
    | "eps"
    | undefined;
  type PageLayout =
    | "a3-landscape"
    | "a3-portrait"
    | "a4-landscape"
    | "a4-portrait"
    | undefined;

  const defaultTitle = "Gisimplify";
  const defaultPageSetup = "a4-landscape";
  const defaultFileFormat = "pdf";

  const [title, setTitle] = React.useState(defaultTitle);
  const [selectedPageSetup, setSelectedPageSetup] =
    React.useState(defaultPageSetup);
  const [selectedFileFormat, setSelectedFileFormat] =
    React.useState(defaultFileFormat);
  const [downloadLinks, setDownloadLinks] = React.useState<
    (string | { url: string; title: string; format: PrintFormat })[]
  >([]);
  const [downloadLink, setDownloadLink] = React.useState<string | null>(null);
  const navigate = useNavigate();
  const [exporting, setExporting] = React.useState(false);

  const ariaLabel = { "aria-label": "description" };
  const [fileFormat, setFileFormat] = React.useState<PrintFormat>("pdf");
  const [selectedFormat, setSelectedFormat] =
    React.useState<PrintFormat>("pdf");
  const [pageSetup, setPageSetup] = React.useState<PageLayout>("a4-portrait");

  const handleTitleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setTitle(event.target.value);
  };

  const handlePageSetupSelect = (option: PageLayout) => {
    setPageSetup(option);
  };

  const handleFileFormatSelect = (option: PrintFormat) => {
    setFileFormat(option);
    setSelectedFormat(option);
  };

  const handleExport = () => {
    setExporting(true);

    const allowedFormats: PrintFormat[] = ["pdf", "jpg", "png8"];
    const allowedLayouts: PageLayout[] = ["a4-landscape", "a4-portrait"];

    if (
      allowedFormats.includes(selectedFormat) &&
      allowedLayouts.includes(pageSetup)
    ) {
      let print = new PrintVM({
        view: store.MapView,
        printServiceUrl:
          "https://utility.arcgisonline.com/arcgis/rest/services/Utilities/PrintingTools/GPServer/Export%20Web%20Map%20Task",
      });

      const printTemplate = new PrintTemplate({
        format: selectedFormat,
        exportOptions: {
          dpi: 300,
        },
        layout: pageSetup,
        layoutOptions: {
          titleText: title,
          authorText: "Gisimplify",
        },
        includeTables: true,
        // includeCharts:true,
        showLabels: true,
      });

      print.print(printTemplate).then((response: any) => {
        const url = response.url;
        setDownloadLink(url);
        setDownloadLinks((prevLinks) =>
          url
            ? [...prevLinks, { url, title, format: selectedFormat }]
            : prevLinks
        );

        setExporting(false);
      });
    } else {
      console.error("Selected format or layout is not allowed.");

      setExporting(false);
    }
  };

  const handleClose = (
    event: React.SyntheticEvent | Event,
    reason?: string
  ) => {
    if (reason !== "backdropClick") {
      dispatch(appActions.setActivePanel(undefined));
      dispatch(
        appActions.setSearchString({
          menu1: "",
          menu2: "",
          menu3: "",
          menu4: "",
          menu5: "",
          menu6: "",
        })
      );
      navigate("../..");
    }
  };

  return (
    <>
      <BasePanel
        openModal={activePanel === "printing"}
        onClose={handleClose}
        panelName={path.services.General[1].title}
        mt="20px"
      >
        <h4 className={styles.min}>Title</h4>

        <Box
          component="form"
          sx={{
            "& > :not(style)": { m: 1 },
          }}
          noValidate
          autoComplete="off"
        >
          <Input
            placeholder="Title of File"
            value={title}
            onChange={handleTitleChange}
            className={styles.in}
          />
        </Box>
        <h4 className={styles.on}>Page Setup</h4>

        <PopupState variant="popover" popupId="page-setup-popup-menu">
          {(popupState) => (
            <React.Fragment>
              <Button
                className={styles.menu}
                variant="contained"
                {...bindTrigger(popupState)}
                style={{ textAlign: "left", paddingRight: "77px" }}
              >
                {selectedPageSetup ? selectedPageSetup : "Page Setup"}
              </Button>
              <Menu {...bindMenu(popupState)}>
                <MenuItem
                  className={styles.menuItem}
                  onClick={() => {
                    handlePageSetupSelect("a4-landscape");
                    setSelectedPageSetup("a4-landscape");
                    popupState.close();
                  }}
                >
                  A4 landscape
                </MenuItem>
                <MenuItem
                  onClick={() => {
                    handlePageSetupSelect("a4-portrait");
                    setSelectedPageSetup("a4-portrait");
                    popupState.close();
                  }}
                >
                  A4 portrait
                </MenuItem>
              </Menu>
            </React.Fragment>
          )}
        </PopupState>
        <h4 className={styles.two}>File Format </h4>

        <PopupState variant="popover" popupId="file-format-popup-menu">
          {(popupState) => (
            <React.Fragment>
              <Button
                className={styles.menu2}
                variant="contained"
                {...bindTrigger(popupState)}
                style={{ textAlign: "left", paddingRight: "150px" }}
              >
                {selectedFileFormat ? selectedFileFormat : "File Format"}
              </Button>
              <Menu {...bindMenu(popupState)}>
                <MenuItem
                  className={styles.menuItem}
                  onClick={() => {
                    handleFileFormatSelect("pdf");
                    setSelectedFileFormat("pdf");
                    popupState.close();
                  }}
                >
                  PDF
                </MenuItem>
                <MenuItem
                  onClick={() => {
                    handleFileFormatSelect("jpg");
                    setSelectedFileFormat("jpg");
                    popupState.close();
                  }}
                >
                  JPG
                </MenuItem>
                <MenuItem
                  onClick={() => {
                    handleFileFormatSelect("png8");
                    setSelectedFileFormat("png8");
                    popupState.close();
                  }}
                >
                  PNG
                </MenuItem>
              </Menu>
            </React.Fragment>
          )}
        </PopupState>

        <Button
          className={styles.menu3}
          variant="contained"
          disableElevation
          onClick={handleExport}
          disabled={exporting}
        >
          Export
        </Button>
        <Divider
          orientation="vertical"
          flexItem
          className={styles.verticalLine}
        />

        <h4 className={styles.three}>Exported files</h4>

        {downloadLinks.map((linkInfo, index) => (
          <div key={index}>
            {typeof linkInfo === "string" ? (
              <a
                href={linkInfo}
                className={styles.anch}
                download={linkInfo}
                target="_blank"
                rel="noopener noreferrer"
              >
                {linkInfo}
              </a>
            ) : (
              <a
                href={linkInfo.url}
                className={styles.anch}
                download={`${linkInfo.title}.${linkInfo.format}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                {`${linkInfo.title}.${linkInfo.format}`}
              </a>
            )}
          </div>
        ))}
      </BasePanel>
    </>
  );
};

export default Printt;
